import { onBeforeUnmount, ref } from 'vue'

export interface ResizeColumnOptions {
  width: number
  minWidth?: number
  maxWidth?: number
  onResize: (width: number) => void
}

function clamp(value: number, min?: number, max?: number): number {
  return Math.min(max ?? Number.POSITIVE_INFINITY, Math.max(min ?? 48, value))
}

export function useResizeColumn() {
  const resizing = ref(false)
  let startX = 0
  let startWidth = 0
  let options: ResizeColumnOptions | null = null

  function stop(): void {
    if (!resizing.value) return
    resizing.value = false
    options = null
    window.removeEventListener('pointermove', move)
    window.removeEventListener('pointerup', stop)
    window.removeEventListener('pointercancel', stop)
    document.body.style.removeProperty('cursor')
    document.body.style.removeProperty('user-select')
  }

  function move(event: PointerEvent): void {
    if (!options) return
    options.onResize(clamp(startWidth + event.clientX - startX, options.minWidth, options.maxWidth))
  }

  function start(event: PointerEvent, next: ResizeColumnOptions): void {
    stop()
    startX = event.clientX
    startWidth = next.width
    options = next
    resizing.value = true
    window.addEventListener('pointermove', move)
    window.addEventListener('pointerup', stop)
    window.addEventListener('pointercancel', stop)
    document.body.style.cursor = 'ew-resize'
    document.body.style.userSelect = 'none'
  }

  onBeforeUnmount(stop)
  return { resizing, start, stop }
}
